import { FaUserFriends, FaBriefcase } from "react-icons/fa";
import { Link } from "react-router-dom";

// 1. Add 'isAdmin' to the props
const TopDoctorCard = ({ doctor, isAdmin }) => {

  // 2. Determine the correct link based on the user's role
  const linkTo = isAdmin ? `/edit-doctor/${doctor.id}` : `https://muktihospital.com/doctor/${doctor.slug}`;

  return (
    <div className="flex 2xl:items-start flex-col 2xl:flex-row gap-6 bg-[#F6F8FB] py-4 px-5 rounded-md">
      <img
        src={`https://api.muktihospital.com${doctor.icon}`}
        alt={doctor.translations?.en.name}
        className="size-20 shrink-0 rounded-full object-cover border-4 border-white"
      />
      <div>
        {/* 3. Use the conditional link */}
        <Link to={linkTo}>
          <h3 className="text-base text-M-text-color font-medium mb-1 hover:text-blue-600">
            {doctor.translations?.en.name}
          </h3>
        </Link>
        <p className="mb-3 text-sm text-M-text-color/60">
          {doctor.translations?.en.designation}
        </p>

        {/* 4. Replace the old review system with new, useful info */}
        <div className="flex flex-col gap-2 font-inter text-M-text-color text-sm">
          <p className="flex items-center gap-2">
            <FaBriefcase size={14} className="text-gray-400" /> 
            {doctor.translations?.en.yearsOfExperience}+ Years Experience
          </p>
          <p className="flex items-center gap-2">
            <FaUserFriends size={14} className="text-gray-400" />
            {doctor.translations?.en.patientAttended}+ Patients
          </p>
        </div>
      </div>
    </div>
  );
};

export default TopDoctorCard;
